import React from 'react';
import { Pepris } from './components/Pepris';

function App() {
  return (
    <div className="min-h-screen">
      <Pepris />
    </div>
  );
}

export default App;